import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { PaymentStatus } from 'src/app/shared/enums/paymentStatus';
import { AdminDataService } from 'src/app/shared/services/admin-data.service';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { VisaStatusService } from 'src/app/shared/services/visa-status.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  constructor(
    private readonly adminDataService: AdminDataService,
    private readonly visaStatusService: VisaStatusService,
    private loadingService: LoadingService,
    private router: Router
  ) {}

  graphicData:any;
  applicationCountsByDay: any[] = [];
  topCountries: any;
  totalSuccessVisaCount: any;
  totalPaymentAmount: any;
  remainingCredit: any;
  visaApplications: any;
  visaStatuses: any;

  exchangeRate: number = 1;
  //totalPaymentAmountTry: number = 0;

  types: string[] = ['spline', 'stackedspline', 'fullstackedspline'];
  title: string = 'Son 7 Gün Başvuru Sayıları';

  async ngOnInit() {
    this.loadingService.show();
    await this.getAdminDashboard();
    await this.getAdminDashboardLastTen();
    await this.getVisaStatuses();
    this.loadingService.hide();
  }

  async getAdminDashboard() {
    const data = await firstValueFrom(
      this.adminDataService.getAdminDashboard()
    );
    this.totalSuccessVisaCount = data.totalSuccessVisaCount;
    this.totalPaymentAmount = data.totalPaymentAmount;
    this.remainingCredit = data.remainingCredit;
    this.visaApplications = data.last10Applications;
    this.exchangeRate = data.exchangeRate;
    //this.totalPaymentAmountTry = data.totalPaymentAmountTry;
  }

  async getAdminDashboardLastTen() {
    this.graphicData = await firstValueFrom(
      this.adminDataService.getAdminDashboardLastTen()
    );
    this.applicationCountsByDay = this.graphicData.applicationCountsByDay;
    this.topCountries = this.graphicData.topCountries;
  }


  customizeLabel(arg: any) {
    return `${arg.argumentText} (${arg.percentText})`;
  }

  // Stil belirleme fonksiyonu
  getPaymentStatusClass(value: number): string {
    switch (value) {
      case PaymentStatus.Pending:
        return 'text-primary'; // Mavi
      case PaymentStatus.Approved:
        return 'text-success'; // Yeşil
      case PaymentStatus.Rejected:
        return 'text-danger'; // Kırmızı
      case PaymentStatus.Unpaid:
        return 'text-warning'; // turuncu
      default:
        return '';
    }
  }

  getVisaStatusLabel(value: number): string {
    const status = this.visaStatuses.find((x: any) => x.id === value);
    const label = status ? status.name : '';
    return label.toUpperCase();
  }
  
  
  getVisaStatusClassByText(value: number): string {
    const status = this.visaStatuses.find((x:any) => x.id === value);
    if (!status) return '';
    switch (status.name.toLowerCase()) {
      case 'onaylandi':
        return 'text-success';
      case 'reddedi̇ldi̇':
        return 'text-danger';
      case 'i̇şlemde':
        return 'text-primary';
      default:
        return '';
    }
  }
  
  async getVisaStatuses(){
    this.visaStatusService.getAll().subscribe(data => {
     this.visaStatuses = data;
   })
 }


 onViewAllApplications() {
  this.router.navigate(['/visa-application-list']);
}
}
